export default "__VITE_ASSET__GKO6mPM3__"